import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { map, takeUntil, filter } from 'rxjs/operators';
import * as fromAuth from '../../reducers';
import * as account from '../../actions/account';
import { ContainerBase } from '../../../core/base/container-base';
var VerifyEmailContainer = /** @class */ (function (_super) {
    tslib_1.__extends(VerifyEmailContainer, _super);
    function VerifyEmailContainer(store, route) {
        var _this = _super.call(this) || this;
        _this.store = store;
        _this.route = route;
        _this.route.params.pipe(takeUntil(_this.destroyed$), filter(function (params) { return params && params['userId']; }), map(function (params) { return params['userId']; })).subscribe(function (userId) {
            if (userId.length !== 24) {
                // Invalid userId
                _this.store.dispatch(new account.UserVerifyEmailFailed(new Error('verify-email.user-not-found')));
            }
            else {
                _this.store.dispatch(new account.UserVerifyEmail(userId));
            }
        });
        _this.verifyEmailWorking$ = _this.store.pipe(select(fromAuth.isVerifyEmailWorking), takeUntil(_this.destroyed$));
        _this.verifyEmailSuccess$ = _this.store.pipe(select(fromAuth.isVerifyEmailSuccess), takeUntil(_this.destroyed$));
        _this.verifyEmailError$ = _this.store.pipe(select(fromAuth.getVerifyEmailError), takeUntil(_this.destroyed$));
        _this.accountValidationResult$ = _this.store.pipe(select(fromAuth.getAccountValidationResult), takeUntil(_this.destroyed$));
        return _this;
    }
    VerifyEmailContainer.prototype.ngOnInit = function () {
    };
    VerifyEmailContainer.prototype.verifyEmail = function (userId) {
        this.store.dispatch(new account.UserVerifyEmail(userId));
    };
    return VerifyEmailContainer;
}(ContainerBase));
export { VerifyEmailContainer };
